import swal from 'sweetalert2'
import axios from 'axios'

export default (recipient) => {
    swal.fire({
        title: 'Skriv meddelande',
        input: 'text',
        inputAttributes: {
            autocapitalize: 'off'
        },
        showCancelButton: true,
        cancelButtonText: "Avbryt",
        confirmButtonText: 'Spara',
        confirmButtonColor: '#006e78',
        showLoaderOnConfirm: true,
        preConfirm: (text) => {
            return axios
                .post(`${window.MYQLOCX_API}/subject/${window.localStorage.userType}/drivers/sms`, { recipient, text })
                .then(res => {
                    return { text: res.data, error: false }
                })
                .catch(err => {
                    return { text: err.response.data, error: true }
                })
        }
    }).then((result) => {
        if (result.dismiss) return

        swal.fire({
            title: '',
            text: `${result.value.text}`,
            type: result.error ? 'error' : 'success',
            confirmButtonColor: '#006e78',
        })
    })
}